import styled from 'styled-components';

export const PrintableDrawerWrapper = styled.div`
    .printable-statement-header {
        padding-bottom: 1rem;
        padding-top: 1rem;
        padding-right: 2rem;
        padding-left: 1rem;

        .filters-line {
            display: flex;
            justify-content: flex-start;
            gap: 0.5rem 1.5rem;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 0.75rem;

            p {
                margin-bottom: 0;
            }
        }
        .button-line {
            text-align: center;
            padding: 0.5rem 0;
        }
    }
`;

export const PrintableExportListWrapper = styled.div`
    padding: 1rem;
    .event-month {
        margin-bottom: 1rem;

        h2 {
            border-top: 1px solid #000;
            border-bottom: 1px solid #000;
            padding: 0.5rem 0;
            margin: 0 0 1rem 0;
            font-size: ${(props) => props.theme.FontSizeXLg};
            font-weight: 600;
        }
        .event-month-days {
            .event-day {
                h3 {
                    font-size: ${(props) => props.theme.FontSizeLg};
                    font-weight: 600;
                    margin-bottom: 1rem;
                }
                margin-bottom: 2.25rem;
                .event-day-events {
                    .event-item {
                        margin-bottom: 0.5rem;
                        h4 {
                            font-size: ${(props) => props.theme.FontSizeBase};
                            font-weight: 600;
                            margin: 0;
                            text-transform: uppercase;
                        }
                        p {
                            margin: 0 0 0.25rem 0;
                            line-height: 1.25;

                            &.description,
                            &.location {
                                white-space: pre-wrap;
                            }

                            &.time {
                                font-style: italic;
                                span {
                                    display: block;
                                }
                            }
                        }

                        &.cancelled {
                            h4 {
                                text-decoration: line-through;
                            }
                            p {
                                text-decoration: line-through;
                            }
                        }
                    }
                }
            }
        }
    }
`;
